import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useState } from 'react';
import { MdArrowForward, MdWarning } from 'react-icons/md';

export interface OpcoesEdicaoPagamentos {
  locacaoEmAndamento: boolean;
  definirPagamentosAnteriorAHojeComoPago: boolean;
}

export interface AlteracaoPagamento {
  titulo: string;
  de: string;
  para: string;
}

interface Params {
  alteracoes: AlteracaoPagamento[];
  exibirOpcoesEmAndamento: boolean;
}

// resolve(null) = usuário cancelou.
export const confirmarEdicaoComRegeracaoDePagamentos = ({ alteracoes, exibirOpcoesEmAndamento }: Params) => {
  return new Promise<OpcoesEdicaoPagamentos | null>((resolve) => {
    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
    overlay.style.zIndex = '9998';
    document.body.appendChild(overlay);

    const removeOverlay = () => {
      if (overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    };

    // Resolve uma única vez e sempre remove o overlay, mesmo se o toast for descartado
    // sem passar pelos botões (ex.: arrasto).
    let finalizado = false;
    const finalizar = (resultado: OpcoesEdicaoPagamentos | null) => {
      if (finalizado) return;
      finalizado = true;
      removeOverlay();
      resolve(resultado);
    };

    const checkboxLabelStyle: React.CSSProperties = {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '8px',
      fontSize: '14px',
      lineHeight: '1.4',
      cursor: 'pointer',
      margin: 0,
    };

    const ConfirmContent = () => {
      const [emAndamento, setEmAndamento] = useState(false);
      const [marcarComoPago, setMarcarComoPago] = useState(false);

      return (
        <div style={{ padding: '20px', color: '#333' }}>
          <div style={{ marginBottom: '12px', fontSize: '15px', fontWeight: 600 }}>
            A sua edição irá recriar os pagamentos desta locação
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '12px' }}>
            {alteracoes.map((alteracao, index) => (
              <div key={index} style={{ fontSize: '14px', lineHeight: '1.4' }}>
                <div style={{ fontWeight: 600, marginBottom: '2px' }}>{alteracao.titulo}</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span>{alteracao.de}</span>
                  <MdArrowForward size={16} color="#1F467E" style={{ flexShrink: 0 }} />
                  <span style={{ fontWeight: 600, color: '#1F467E' }}>{alteracao.para}</span>
                </div>
              </div>
            ))}
          </div>

          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '12px', fontSize: '13px', lineHeight: '1.4', color: '#8a6d3b', background: '#fcf8e3', border: '1px solid #faebcc', borderRadius: '4px', padding: '8px 10px' }}>
            <MdWarning size={16} color="#8a6d3b" style={{ flexShrink: 0, marginTop: '1px' }} />
            <span>Os pagamentos atuais serão apagados e recriados com base na nova configuração.</span>
          </div>

          {exibirOpcoesEmAndamento && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '16px' }}>
              <label style={checkboxLabelStyle}>
                <input
                  type="checkbox"
                  checked={emAndamento}
                  onChange={(e) => setEmAndamento(e.target.checked)}
                  style={{ marginTop: '3px' }}
                />
                <span>
                  <strong>Locação em andamento:</strong> gerar os pagamentos desde o início da locação até hoje
                  e contar o prazo do contrato a partir de hoje (como no cadastro).
                </span>
              </label>
              <label style={checkboxLabelStyle}>
                <input
                  type="checkbox"
                  checked={marcarComoPago}
                  onChange={(e) => setMarcarComoPago(e.target.checked)}
                  style={{ marginTop: '3px' }}
                />
                <span>
                  <strong>Definir os pagamentos anteriores a hoje como recebidos</strong> (evita que o histórico
                  recriado fique como pendente).
                </span>
              </label>
            </div>
          )}

          <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
            <button
              onClick={() => {
                finalizar(null);
                toast.dismiss(toastId);
              }}
              style={{
                background: 'transparent',
                color: '#1F467E',
                border: '1px solid #1F467E',
                padding: '8px 16px',
                borderRadius: '4px',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.2s',
                minWidth: '90px',
              }}
              onMouseOver={(e) => (e.currentTarget.style.opacity = '0.8')}
              onMouseOut={(e) => (e.currentTarget.style.opacity = '1')}
            >
              Cancelar
            </button>

            <button
              onClick={() => {
                finalizar({
                  locacaoEmAndamento: exibirOpcoesEmAndamento && emAndamento,
                  definirPagamentosAnteriorAHojeComoPago: exibirOpcoesEmAndamento && marcarComoPago,
                });
                toast.dismiss(toastId);
              }}
              style={{
                background: '#1F467E',
                color: 'white',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '4px',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.2s',
                minWidth: '110px',
              }}
            >
              Confirmar
            </button>
          </div>
        </div>
      );
    };

    const toastId = toast(<ConfirmContent />, {
      closeOnClick: false,
      closeButton: false,
      autoClose: false,
      draggable: false,
      onClose: () => finalizar(null),
      position: 'top-center',
      style: {
        background: 'white',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
        borderRadius: '8px',
        borderLeft: '6px solid #1F467E',
        width: 'auto',
        maxWidth: '480px',
        zIndex: '9999',
      },
      bodyStyle: {
        padding: 0,
      },
    });
  });
};
